import { render, staticRenderFns } from "./QuickLabel.vue?vue&type=template&id=693be2fb&scoped=true&"
import script from "./QuickLabel.vue?vue&type=script&lang=js&"
export * from "./QuickLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693be2fb",
  null
  
)

export default component.exports